// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"106":"72a5cd32","214":"5b19f79b","948":"5782c2c1"}[chunkId] + ".css";
};